import firebase from 'firebase/compat/app';
import { firebaseConfig } from './firebaseconfig';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import Swal from 'sweetalert';

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}
const db = firebase.firestore();
const storage = firebase.storage();

// PEGAR O ANO ATUAL
const dataAtual = new Date();
const anoAtual = dataAtual.getFullYear();
localStorage.setItem('ano', anoAtual);
const ANO = localStorage.getItem('ano');

const lerDuvidasCentralAtendimento = async () => {
    const duvidas = [];
    const lerDuvidas = new Promise( async (resolve, reject) => {
        try {
            db.collection(ANO)
            .doc('duvidas')
            .collection('pais')
            .orderBy('data')
            .onSnapshot((data) => {
                const tamanho = data.size;
                if (tamanho === 0) {
                    resolve(false);
                } else {
                    data.docs.map((val) => {
                        const id = val.id;
                        const usuario = val.data().usuario;
                        const mensagem = val.data().mensagem;
                        duvidas.push({
                            usuario: usuario,
                            mensagem: mensagem,
                            id: id
                        });
                    });
                    resolve(duvidas);
                }
            }); 
        } catch (error) {
            console.error('Erro ao ler evento:', error);
            throw error;
            reject(error);
        }
    });
    
    return lerDuvidas;
};


const enviarDuvidaCentralAtendimento = async (usuario, mensagem) => {
    
    const enviarDuvida = new Promise( async (resolve, reject) => {
        try {
            if (mensagem) {
                await db.collection(ANO)
                .doc('duvidas')
                .collection('pais')
                .add({
                    usuario: usuario,
                    mensagem: mensagem,
                    data: firebase.firestore.FieldValue.serverTimestamp(),
                }).then((res) => {
                    Swal({
                        title: 'Dúvida enviada com sucesso!',
                        icon: 'success',
                        buttons: {
                            confirm: 'Ok',
                        },
                    });
                });
            } else {
                Swal({
                    title: 'Mensagem inválida!',
                    icon: 'error',
                    buttons: {
                        confirm: 'Ok',
                    },
                });
            }
            
        } catch (error) {
            console.error('Erro ao ler evento:', error);
            throw error;
            reject(error);
        }
    });
    
    return enviarDuvida;
};



export { lerDuvidasCentralAtendimento, enviarDuvidaCentralAtendimento };